module.exports = __webpack_public_path__ + "img/error404-custom.abc5b048.svg";